import { useMutation } from '@tanstack/react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import type { LoginDto } from '@fp3/shared'
import { resolvePostLoginDestination } from '@/lib/auth/redirectTarget'
import { authApi } from '../api/authApi'
import { getSafeRedirect } from '../lib/safeRedirect'
import { useAuth } from './useAuth'

export const useLogin = () => {
  const { login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  return useMutation({
    mutationFn: (dto: LoginDto) => authApi.login(dto),
    onSuccess: (data) => {
      login(data.access_token, data.user)
      // a satellite app behind SSO forward-auth sends the user here with ?rd=<its URL>;
      // after login, leave the SPA and return there (validated against the SSO domain)
      const rd = getSafeRedirect(new URLSearchParams(location.search).get('rd'))
      if (rd) {
        window.location.assign(rd)
        return
      }
      // return the user to the URL they originally requested, falling back to the
      // default landing page; the route guard stashes it in location.state.from and
      // the 401 interceptor persists it across a hard reload
      const capturedFrom = (location.state as { from?: unknown } | null)?.from
      navigate(resolvePostLoginDestination(capturedFrom), { replace: true })
    },
  })
}
